import React from 'react';
import Loadable from 'react-loadable';

const Experience360Lazy = Loadable({
  loader: () => import('./index.lazy'),
  loading: () => (<div />),
});

export default Experience360Lazy;
